<template>
    <div class="two">
        <el-carousel
            class="two-carousel"
            :autoplay="false"
            ref="oneCarousel"
            indicator-position="none"
            arrow="never"
        >
            <el-carousel-item
                class="two-carousel__item"
                :class="{ 'dark-model': item.dark_model }"
                v-for="(item, index) in detailData"
                :key="item.id"
            >
                <div class="two-content">
                    <div class="two-content__left">
                        <img :src="item.acf.image" alt="" />
                    </div>
                    <div class="two-content__right">
                        <div class="two-content__title">
                            <h2>{{ item.title.rendered }}</h2>
                        </div>
                        <div class="two-content__date">
                            {{ item.date | formatDate("yyyy-MM-dd") }}
                        </div>
                        <div class="two-content__desc" v-html="item.excerpt.rendered">
                        </div>
                        <div class="two-content__color">
                            <div v-show="false" class="ht">颜色</div>
                            <div v-show="false"  class="hd">
                                <div class="color-list">
                                    <div class="color-list__item">
                                        <span class="cr-1">red</span>
                                        <span class="cr-text">红色</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="two-content__action">
                            <div class="two-carousel__buttons">
                                <span
                                    v-on:click="carousel_prev()"
                                    class="two-carousel__button prev"
                                    ><v-icon
                                        class="two-carousel__button-icon"
                                        name="bi-arrow-left-circle-fill"
                                    ></v-icon
                                ></span>
                                <span class="two-carousel__button-text"
                                    >{{ index + 1 }} / {{ detailData.length }}</span
                                >
                                <span
                                    v-on:click="carousel_next()"
                                    class="two-carousel__button next"
                                    ><v-icon
                                        class="two-carousel__button-icon"
                                        name="bi-arrow-right-circle-fill"
                                    ></v-icon
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
        <!-- <div class="two-carousel__control">
            <div class="two-carousel__buttons">
                <span v-on:click="carousel_prev()" class="two-carousel__button prev"
                    ><v-icon
                        class="two-carousel__button-icon"
                        name="bi-arrow-left-circle-fill"
                    ></v-icon
                ></span>
                <span class="two-carousel__button-text">1 / 3</span>
                <span  v-on:click="carousel_next()" class="two-carousel__button next"
                    ><v-icon
                        class="two-carousel__button-icon"
                        name="bi-arrow-right-circle-fill"
                    ></v-icon
                ></span>
            </div>
        </div> -->
    </div>
</template>
<script>
import Vue from "vue";
import { Carousel, CarouselItem } from "element-ui";
Vue.use(Carousel).use(CarouselItem);

// https://static.fun2ex.com/w1.jpg?imageMogr2/thumbnail/1920x
// https://static.fun2ex.com/w2.jpg?imageMogr2/thumbnail/1920x
// https://static.fun2ex.com/w3.jpg?imageMogr2/thumbnail/1920x
// https://static.fun2ex.com/w4.jpg?imageMogr2/thumbnail/1920x

export default {
    name: "HomeCarousel",
    props: {
        detailData: Array
    },
    data() {
        return {
            one: [
                {
                    id: 1,
                    title: "PE 管束材料",
                    sub_title: "",
                    date: "2021-03-24",
                    desc: "雄塑家装专用PP-R管道作为新型管材的典型代表，专为家庭装修量身定制，采用独特的生产工艺，有效调控管材内部微分子结构，显著改善管材的抗低温冲击性，提高产品物理化学性能，从而解决了PP-R低温偏脆的普遍性难题，作为性价比极高的管材之一，雄塑管道将为家装管道系统的提供优质产品及服务。",
                    url: "https://fun2ex.com",
                    image: "https://temp.im/800x514/007AFF/fff",
                    dark_model: false,
                    tag: "PE",
                },
                {
                    id: 2,
                    title: "PE 管束材料",
                    sub_title: "",
                    date: "2021-03-24",
                    desc: "雄塑家装专用PP-R管道作为新型管材的典型代表，专为家庭装修量身定制，采用独特的生产工艺，有效调控管材内部微分子结构，显著改善管材的抗低温冲击性，提高产品物理化学性能，从而解决了PP-R低温偏脆的普遍性难题，作为性价比极高的管材之一，雄塑管道将为家装管道系统的提供优质产品及服务。",
                    url: "https://fun2ex.com",
                    image: "https://temp.im/800x514/007AFF/fff?v=2",
                    dark_model: false,
                    tag: "PVC",
                },
                {
                    id: 3,
                    title: "PE 管束材料",
                    sub_title: "ISO9001和ISO14001认证",
                    date: "2021-03-24",
                    desc: "雄塑家装专用PP-R管道作为新型管材的典型代表，专为家庭装修量身定制，采用独特的生产工艺，有效调控管材内部微分子结构，显著改善管材的抗低温冲击性，提高产品物理化学性能，从而解决了PP-R低温偏脆的普遍性难题，作为性价比极高的管材之一，雄塑管道将为家装管道系统的提供优质产品及服务。",
                    url: "https://fun2ex.com",
                    image: "https://temp.im/800x514/007AFF/fff?v=3",
                    dark_model: true,
                    tag: "PVC-E",
                },
                {
                    id: 4,
                    title: "PE 管束材料",
                    sub_title: "",
                    date: "2021-03-24",
                    desc: "雄塑家装专用PP-R管道作为新型管材的典型代表，专为家庭装修量身定制，采用独特的生产工艺，有效调控管材内部微分子结构，显著改善管材的抗低温冲击性，提高产品物理化学性能，从而解决了PP-R低温偏脆的普遍性难题，作为性价比极高的管材之一，雄塑管道将为家装管道系统的提供优质产品及服务。",
                    url: "https://fun2ex.com",
                    image: "https://temp.im/800x514/007AFF/fff?v=4",
                    dark_model: true,
                    tag: "PVC-NN",
                },
            ],
        };
    },
    mounted() {
        this.carousel_count();
    },
    methods: {
        hello() {
            alert("ddd");
        },
        carousel_prev() {
            // prev() {
            // console.log(this.$refs)
            this.$refs.oneCarousel.prev();
            // },
            // next() {
            // }
        },
        carousel_next() {
            this.$refs.oneCarousel.next();
        },
        carousel_count() {
            console.info(this.detailData)
        },
    },
};
</script>
<style lang="scss">
.two {
    position: relative;

    &-carousel {
        width: 100%;
        height: 514px;

        &__item {
            height: 514px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
        }

        &__buttons {
            display: flex;
            align-items: center;
        }
        &__button {
            color: #1b70f0;
            background: #fff;
            border-radius: 40px;
            width: 40px;
            height: 40px;
            overflow: hidden;
            position: relative;
            cursor: pointer;

            &-text {
                padding: 0 10px;
                // color: rgba(204, 221, 237, 1);
                color: #000;
            }

            &-icon {
                width: 50px;
                height: 50px;
                left: 50%;
                top: 50%;
                position: absolute;
                color: #c3c3c3;
                transform: translate(-50%, -50%);
            }
        }

        &__control {
            position: absolute;
            z-index: 2;
            bottom: 20%;
            right: 350px;
            transform: translate(-50%, 0);
            // transform:
        }
    }

    &-content {
        height: 514px;
        width: 100%;
        // background: rgba(0, 0, 0, 0.2);
        color: #000;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;

        &__left {
            padding-right: 60px;
            width: 800px;
            height: 514px;
            flex: none;

            img {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
        &__right {
            padding: 20px 0;
            width: 100%;
        }

        &__other {
            .text {
                font-size: 18px;
                font-weight: 600;
                text-transform: uppercase;
            }
            .bottom-line {
                width: 60px;
                height: 2px;
                margin-top: 10px;
                background: #000;
            }
        }

        &__title {
            font-size: 20px;
            padding-bottom: 20px;
        }

        &__date {
            padding-bottom: 30px;
        }

        &__desc {
            // text-overflow: ellipsis;
            // word-break: break-all;
            
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 2;
            height: 7em;
            overflow: hidden;
            font-size: 16px;
            font-weight: normal;
            line-height: 1.8;
            color: #666666;
        }

        &__color {
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #c3c3c3;
            .ht {
                font-size: 18px;
                padding-bottom: 20px;
            }
            .color-list {
                display: flex;
                text-align: center;
                span {
                    display: block;
                }
            }

            .cr-1 {
                background: #F7F7F3;
                box-shadow: inset 0px 1px 5px rgba(0, 0, 0, 0.2);
                width: 40px;
                height: 40px;
                border-radius: 100px;
                font-size: 0;
            }
            .cr-text {
                font-size: 14px;
                padding-top: 10px;
            }
        }
        &__action {
            padding-top: 30px;
        }
    }
}
</style>
